import request from '../utils/request'


export function index(params) {
  return request({
    url: '/purposeHospitalizations',
    method: 'get',
      params
  })
}

export function inventory(params) {
  return request({
    url: '/purposeHospitalizations/inventory',
    method: 'get',
    params
  })
}

  

export function show(id) {
    return request({
      url: `/purposeHospitalizations/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/purposeHospitalizations',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/purposeHospitalizations/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/purposeHospitalizations/${id}`,
      method: 'delete',
    })
  }
